var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProfissionais = function SvgProfissionais(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#498FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M22 19a4 4 0 0 1 4 4v4.04c-3.077 2.655-6.41 3.975-9.998 3.96C12.414 30.985 9.08 29.665 6 27.04V23a4 4 0 0 1 4-4zM16 6a5 5 0 1 1 0 10 5 5 0 0 1 0-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003A79",
    d: "M21.037 19c.866.676 1.134 1.267 1.134 2.037v.827c1.476.272 1.829 1.612 1.829 2.493v1.902c0 .41-.358.741-.799.741-.44 0-.798-.332-.798-.74 0-.336.24-.62.57-.71l.001-1.193c0-.803-.613-1.454-1.37-1.454-.757 0-1.37.65-1.37 1.454v1.192c.33.09.571.375.571.71 0 .41-.357.741-.798.741-.404 0-.739-.279-.791-.64l-.008-.1v-1.903c0-.88.353-2.22 1.828-2.493l.001-.827c0-1.074-.557-1.314-1.567-2.037h1.567zm-8.814 0c-.683 1.486-1.017 2.526-1.001 3.119.02.777.211 1.774 1.12 2.012.204-.196.49-.316.805-.316.622 0 1.126.467 1.126 1.044s-.504 1.045-1.126 1.045c-.511 0-.943-.316-1.08-.748C10.89 24.88 10 23.896 10 22.119c0-1.416.334-2.455 1.001-3.119h1.222zm.596 0c0-.001 6.252 0 6.252.024-.261 1.393-1.303 3.113-3.124 5.16C14.116 22.129 13.073 20.4 12.82 19z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfissionais, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profissionais.84156f5b.svg";
export { ForwardRef as ReactComponent };